import { render, staticRenderFns } from "./template-usage-report.vue?vue&type=template&id=85956f60&"
import script from "./template-usage-report.vue?vue&type=script&lang=js&"
export * from "./template-usage-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports